import RestApiModel from "@/api/Model/RestApiModel";
import Sections from '@/api/Facility/Sections';
import Markets from '@/api/Facility/Markets';
import DistributionList from '@/api/Facility/DistributionList';
import FDO from '@/api/Facility/FDO';
import Underwriter from '@/api/Facility/Underwriter';
import api from '../index';

class Facility extends RestApiModel {
  static sections = Sections;
  static markets = Markets;
  static fdos = FDO;
  static distributionLists = DistributionList;
  static underwriters = Underwriter;

  static getResourceEndpoint() {
    return '/facilities';
  }

  /**
   * @returns {Promise<AxiosResponse<any>>}
   */
  static counts() {
    return this.list({endpoint: this.getResourceEndpoint() + '/counts'});
  }

  /**
   * @param id
   * @param isPublished
   * @returns {*}
   */
  static publish(id, isPublished) {
    return api.patch(`${this.getResourceIdEndpoint(id)}/publish`, {isPublished});
  }

  /**
   * @param id
   * @param isEnabled
   * @returns {*}
   */
  static enable(id, isEnabled) {
    return api.patch(`${this.getResourceIdEndpoint(id)}/enable`, {isEnabled});
  }

  /**
   * Get pending change logs for a facility
   * @param facilityId
   * @returns {*}
   */
  static getPendingChangeLogs(facilityId) {
    return api.get(`/facilities/${facilityId}/change-logs`, {
      params: {
        status: 'pending'
      }
    });
  }


  /**
   * Get all change logs for a facility
   * @param facilityId
   * @returns {*}
   */
  static getChangeLogs(facilityId) {
    return api.get(`/facilities/${facilityId}/change-logs`);
  }

  /**
   * Get a specific change log
   * @param facilityId
   * @param changeLogId
   * @returns {*}
   */
  static getChangeLog(facilityId, changeLogId) {
    return api.get(`/facilities/${facilityId}/change-logs/${changeLogId}`);
  }

  /**
   * Approve a change log
   * @param facilityId
   * @param changeLogId
   * @returns {*}
   */
  static approveChangeLog(facilityId, changeLogId) {
    return api.patch(`/facilities/${facilityId}/change-logs/${changeLogId}/approve`);
  }

  /**
   * Reject a change log
   * @param facilityId
   * @param changeLogId
   * @returns {*}
   */
  static rejectChangeLog(facilityId, changeLogId) {
    return api.patch(`/facilities/${facilityId}/change-logs/${changeLogId}/reject`);
  }

  /**
   * Check if a facility has pending change logs
   * @param id
   * @returns {*}
   */
  static hasPendingChanges(id) {
    return api.get(`/facilities/${id}/has-pending-changes`);
  }
}

export default Facility;
